var map = {
	".": "Q3ZN",
	"./": "Q3ZN",
	"./01_dept_info_interval": "0EuA",
	"./01_dept_info_interval.json": "0EuA",
	"./02_latest_records": "4L7x",
	"./02_latest_records.json": "4L7x",
	"./03_kline_data": "zKQU",
	"./03_kline_data.json": "zKQU",
	"./04_quote_ticker": "xVTF",
	"./04_quote_ticker.json": "xVTF",
	"./05_last_trade_price": "gvF4",
	"./05_last_trade_price.json": "gvF4",
	"./06_last_mark_price": "pgER",
	"./06_last_mark_price.json": "pgER",
	"./07_book_ticker": "wF+v",
	"./07_book_ticker.json": "wF+v",
	"./08_depth_incr_info": "hH3F",
	"./08_depth_incr_info.json": "hH3F",
	"./index": "Q3ZN",
	"./index.js": "Q3ZN"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "jPjn";


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/swapV2/websocket/market ^.*$
// module id = jPjn
// module chunks = 3